"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var w3c_keys_1 = require("w3c-keys");

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var ReactUtils_1 = require("../../../utils/ReactUtils");

var Drawer_1 = require("../../atoms/_Drawer/Drawer");

var IndicatorLinks_1 = require("../../atoms/_IndicatorLinks/IndicatorLinks");

var TabBar_1 = require("../../atoms/_TabBar/TabBar");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../../molecules/IconLink");

var Logo_1 = require("../../molecules/Logo");

var Header =
/** @class */
function (_super) {
  __extends(Header, _super);

  function Header(props) {
    var _this = _super.call(this, props) || this;

    _this.onTabBarKeyDown = function (_openIndex, event) {
      var openIndexSelected = _this.cleanNavigationItems.findIndex(function (item) {
        return item.isSelected;
      });

      switch (event.key) {
        case w3c_keys_1.Key.ArrowDown:
          event.preventDefault();

          _this.setState({
            menuOpen: true,
            selectedPath: _this.keyPaths.right
          });

          return;

        case w3c_keys_1.Key.Enter:
          event.preventDefault();
          var selectedItem = _this.cleanNavigationItems[openIndexSelected];

          if (selectedItem.children.length === 0) {
            _this.props.onChange(selectedItem.targetValue, _this.props.name, event);

            return;
          }

          _this.setState({
            menuOpen: !_this.state.menuOpen
          });

          return;

        case w3c_keys_1.Key.Escape:
          event.preventDefault();

          _this.closeMenu(false);

          return;

        case w3c_keys_1.Key.Tab:
          var index = _this.cleanNavigationItems.findIndex(function (item) {
            return item.targetValue === _this.state.selectedPath[0];
          });

          if (!_this.state.menuOpen && (event.shiftKey && index === 0 || index === _this.cleanNavigationItems.length - 1)) {
            _this.setState({
              selectedPath: []
            });

            return;
          }

          if (_this.state.menuOpen && event.shiftKey) {
            _this.setState({
              selectedPath: [],
              menuOpen: false
            });

            return;
          }

          break;

        case w3c_keys_1.Key.ArrowLeft:
          var newIndexLeft = openIndexSelected > 0 ? openIndexSelected - 1 : _this.cleanNavigationItems.length - 1;

          _this.setState({
            selectedPath: [_this.cleanNavigationItems[newIndexLeft].targetValue]
          });

          return;

        case w3c_keys_1.Key.ArrowRight:
          var newIndexRight = openIndexSelected < _this.cleanNavigationItems.length - 1 ? openIndexSelected + 1 : 0;

          _this.setState({
            selectedPath: [_this.cleanNavigationItems[newIndexRight].targetValue]
          });

          return;

        default:
          break;
      }
    };

    _this.onTabBarMouseDown = function () {
      _this.selectedPathMouseDown = _this.state.selectedPath.slice();
    };

    _this.onTabBarClick = function (openIndex) {
      var targetValue = _this.cleanNavigationItems[openIndex].targetValue;
      var sameTarget = _this.selectedPathMouseDown.length && _this.selectedPathMouseDown[0] === targetValue;

      _this.setState(function (oldState) {
        return {
          menuOpen: sameTarget ? !oldState.menuOpen : true,
          selectedPath: sameTarget ? [] : [targetValue]
        };
      });
    };

    _this.onMobileMainItemClick = function (targetValue) {
      var level1Index = _this.cleanNavigationItems.findIndex(function (item) {
        return item.targetValue === targetValue;
      });

      var level1Item = _this.cleanNavigationItems[level1Index];
      var level2Item = level1Item ? level1Item.children.find(function (item) {
        return item.isSelectable;
      }) : undefined;
      var level3Item = level2Item ? level2Item.children[0] : undefined; // right opens the next menu level

      var selectedPath = [level1Item && level1Item.targetValue, level2Item && level2Item.targetValue, level3Item && level3Item.targetValue].filter(function (value) {
        return value !== undefined;
      });

      _this.setState({
        selectedPath: selectedPath
      });
    };

    _this.onTabBarItemFocus = function (index) {
      var targetValue = _this.cleanNavigationItems[index].targetValue;

      if (_this.state.selectedPath.length === 0 || _this.state.selectedPath[0] !== targetValue) {
        _this.setState({
          selectedPath: [targetValue]
        });
      }
    };

    _this.onMobileBackwardsClick = function () {
      _this.setState(function (oldState) {
        return {
          selectedPath: oldState.selectedPath.slice(0, 1)
        };
      });
    };

    _this.closeMenuBackdrop = function (event) {
      if (!utils_1.DomUtils.isTargetInsideContainer(event.target, _this.tabBarRef)) {
        _this.closeMenu(true);
      }
    };

    _this.closeMenu = function (isMouseTriggerOrEvent) {
      var isMouseTrigger = typeof isMouseTriggerOrEvent === "boolean" ? isMouseTriggerOrEvent : isMouseTriggerOrEvent.nativeEvent instanceof MouseEvent; // remove the focus from the menu if the menu is closed by a mouse click or if the selected entry is on level 1

      var selectedPath = isMouseTrigger ? [] : _this.state.selectedPath.slice(0, 1);

      _this.setState({
        selectedPath: selectedPath,
        menuOpen: false
      }); //HACK: workaround for mobile landingpage
      // make sure the viewport is left aligned when menu closes
      // (content is scrolled a few pixels to the left on iOS otherwise)


      if (document && document.body) {
        document.body.scrollLeft = 0;
      }
    };

    _this.openMenu = function () {
      _this.setState({
        menuOpen: true,
        selectedPath: _this.cleanNavigationItems.length ? [_this.cleanNavigationItems[0].targetValue] : []
      });
    };

    _this.onItemKeyDown = function (event) {
      switch (event.key) {
        case w3c_keys_1.Key.ArrowUp:
          event.preventDefault();

          _this.setState({
            selectedPath: _this.keyPaths.up
          });

          return;

        case w3c_keys_1.Key.ArrowDown:
          event.preventDefault();

          _this.setState({
            selectedPath: _this.keyPaths.down
          });

          return;

        case w3c_keys_1.Key.ArrowLeft:
          event.preventDefault();

          _this.setState({
            selectedPath: _this.keyPaths.left
          });

          return;

        case w3c_keys_1.Key.ArrowRight:
          event.preventDefault();

          _this.setState({
            selectedPath: _this.keyPaths.right
          });

          return;

        case w3c_keys_1.Key.Home:
          event.preventDefault();

          _this.setState({
            selectedPath: _this.keyPaths.home
          });

          return;

        case w3c_keys_1.Key.End:
          event.preventDefault();

          _this.setState({
            selectedPath: _this.keyPaths.end
          });

          return;

        case w3c_keys_1.Key.Escape:
          event.preventDefault();

          _this.closeMenu(false);

          return;

        default:
          break;
      }
    };

    _this.getLink = function (node, overrides, lastLevel) {
      if (lastLevel === void 0) {
        lastLevel = false;
      }

      if (node.children.length > 0 && !lastLevel) {
        return overrides;
      }

      if (node.href) {
        return {
          href: node.href,
          target: node.href,
          onClick: overrides.onClick,
          onMouseDown: overrides.onMouseDown,
          onFocus: overrides.onFocus
        };
      }

      var onChange = function onChange(event) {
        _this.props.onChange(node.targetValue, _this.props.name, event);

        _this.closeMenu(true);
      };

      return {
        onClick: node.onClick || onChange,
        onMouseDown: overrides.onMouseDown,
        onFocus: overrides.onFocus
      };
    };

    _this.uuid = _this.props.id || uniqid_1["default"]("PortalNavigation-");
    _this.drawerContentRef = React.createRef();
    _this.state = {
      menuOpen: false,
      isMobile: false,
      selectedPath: []
    };
    return _this;
  }

  Header.prototype.componentDidUpdate = function () {
    var _this = this;

    if (this.selectedElementRef) {
      if (this.state.isMobile) {
        // focus after animation to avoid animation lags, keep in sync with scss animation in _Header.scss
        setTimeout(function () {
          return _this.selectedElementRef.focus();
        }, parseFloat(window.getComputedStyle(this.drawerContentRef.current).transitionDuration) * 1000);
      } else {
        this.selectedElementRef.focus();
      }
    }
  };

  Header.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        segmentLabel = _a.segmentLabel,
        logoHref = _a.logoHref,
        navigationObject = _a.navigationObject,
        activeValue = _a.activeValue,
        name = _a.name,
        iconLinksLanguage = _a.iconLinksLanguage,
        iconLinksLogin = _a.iconLinksLogin,
        iconLinksSearch = _a.iconLinksSearch,
        iconLinksSegment = _a.iconLinksSegment;
    var _b = this.state,
        selectedPath = _b.selectedPath,
        menuOpen = _b.menuOpen;
    this.cleanNavigationItems = utils_1.NavigationUtils.cleanupNavigationItemsHeader(navigationObject, selectedPath, activeValue, name);
    var drawerItemIndex = this.cleanNavigationItems.findIndex(function (item) {
      return item.isSelected;
    });
    var drawerNavigationItems = drawerItemIndex < 0 ? [] : this.cleanNavigationItems[drawerItemIndex].children;
    var tabBarOpenIndexSelected = this.cleanNavigationItems.findIndex(function (item) {
      return item.isSelected;
    });
    var tabBarOpenIndex = tabBarOpenIndexSelected === -1 || !menuOpen ? this.cleanNavigationItems.findIndex(function (item) {
      return item.isActive;
    }) : tabBarOpenIndexSelected;
    this.keyPaths = utils_1.NavigationUtils.getKeyPaths(this.cleanNavigationItems, selectedPath.length > 0 ? selectedPath : []);
    this.selectedElementRef = undefined;
    var result = React.createElement("header", {
      id: this.uuid,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header", className, this.state.isMobile ? CSSPrefix_1.lsgPre + "header__mobile" : CSSPrefix_1.lsgPre + "header__desktop"]),
      role: "banner"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-inner"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-logoarea"
    }, React.createElement(Logo_1.Logo, {
      href: logoHref
    })), !this.state.isMobile && React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-segment-label"
    }, segmentLabel), React.createElement(IconLink_1.IconLinkGroup, {
      className: CSSPrefix_1.lsgPre + "header-primary-icons",
      direction: IconLink_1.IconLinkGroup.Directions.HORIZONTAL
    }, this.state.isMobile && ReactUtils_1.ReactUtils.map(iconLinksSearch, function (iconLink) {
      return React.cloneElement(iconLink, {
        look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER
      });
    }), !this.state.isMobile && iconLinksSegment, ReactUtils_1.ReactUtils.map(iconLinksLogin, function (iconLink) {
      return !_this.state.isMobile ? iconLink : React.cloneElement(iconLink, {
        look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER
      });
    }), this.state.isMobile && React.createElement(IconLink_1.IconLink, {
      className: CSSPrefix_1.lsgPre + "header-burger-icon",
      iconName: Icon_1.Icon.Names.interaction___menu,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: this.openMenu
    }, utils_1.Localization.texts.lsg.component.Header.openMenu))), React.createElement("nav", {
      className: CSSPrefix_1.lsgPre + "header-nav",
      "aria-hidden": this.state.isMobile
    }, React.createElement(TabBar_1.TabBar, {
      openIndex: tabBarOpenIndex,
      onKeyDown: this.onTabBarKeyDown,
      fullIndicatorWhenUnselected: true,
      focusAllItems: true,
      onItemsDontFit: function onItemsDontFit(itemsFit) {
        return _this.state.isMobile !== !itemsFit && _this.setState(function (oldState) {
          return __assign(__assign({}, oldState), {
            isMobile: !itemsFit
          });
        });
      },
      secondaryItems: React.createElement(IconLink_1.IconLinkGroup, {
        direction: IconLink_1.IconLinkGroup.Directions.HORIZONTAL
      }, ReactUtils_1.ReactUtils.map(iconLinksSearch, function (iconLink) {
        return React.cloneElement(iconLink, {
          look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER
        });
      }), iconLinksLanguage),
      refCallback: function refCallback(r) {
        return _this.tabBarRef = r;
      }
    }, this.cleanNavigationItems.map(function (item, i) {
      return React.createElement(TabBar_1.TabBar.Item, __assign({}, _this.getLink(item, {
        onClick: function onClick() {
          return _this.onTabBarClick(i);
        },
        onMouseDown: _this.onTabBarMouseDown,
        onFocus: function onFocus() {
          return _this.onTabBarItemFocus(i);
        }
      }), {
        label: item.label.toString(),
        active: item.isActive,
        refCallback: function refCallback(r) {
          if (item.isSelected) {
            _this.selectedElementRef = r;
          }
        },
        key: item.targetValue
      }));
    }))), React.createElement(Drawer_1.Drawer, {
      id: this.uuid + "-mega-menu",
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "header-drawer", selectedPath.length > 1 ? CSSPrefix_1.lsgPre + "header-drawer__level2" : CSSPrefix_1.lsgPre + "header-drawer__level1"]),
      open: this.state.menuOpen,
      layout: !this.state.isMobile ? Drawer_1.Drawer.Layout.MEGAMENU : Drawer_1.Drawer.Layout.LAYER_RIGHT,
      onCloseClick: this.closeMenu,
      onBackdropClick: this.closeMenuBackdrop,
      htmlAttrs: {
        role: undefined,
        "aria-modal": undefined
        /* unset because this is a menu */

      },
      noFocusLock: !this.state.isMobile
    }, this.state.isMobile && React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-drawer-level1",
      ref: this.drawerContentRef
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-drawer-header"
    }, React.createElement(IconLink_1.IconLink, {
      className: CSSPrefix_1.lsgPre + "header-drawer-close-link",
      iconName: Icon_1.Icon.Names.interaction___close,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: this.closeMenu
    }, utils_1.Localization.texts && utils_1.Localization.texts.lsg.component.Header.closeDrawer)), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-drawer-contents"
    }, React.createElement(IndicatorLinks_1.IndicatorLinks, {
      indicator: true,
      activeIndex: this.cleanNavigationItems.findIndex(function (item) {
        return item.isActive;
      })
    }, this.cleanNavigationItems.filter(function (item) {
      return !item.noMobile;
    }).map(function (item) {
      return React.createElement(IndicatorLinks_1.IndicatorLinks.Link, __assign({}, _this.getLink(item, {
        onClick: function onClick() {
          return _this.onMobileMainItemClick(item.targetValue);
        },
        onKeyDown: _this.onItemKeyDown
      }), {
        label: item.label.toString(),
        iconName: item.iconName,
        key: item.targetValue,
        refCallback: function refCallback(r) {
          if (_this.state.isMobile && item.isSelected) {
            _this.selectedElementRef = r;
          }
        }
      }));
    })), React.createElement(IconLink_1.IconLinkGroup, {
      direction: IconLink_1.IconLinkGroup.Directions.VERTICAL
    }, iconLinksLogin, iconLinksSearch, iconLinksLanguage, iconLinksSegment))), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-drawer-level2",
      ref: this.drawerContentRef
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-drawer-header"
    }, this.state.isMobile && selectedPath.length > 1 && React.createElement(IconLink_1.IconLink, {
      className: CSSPrefix_1.lsgPre + "header-drawer-back-link",
      iconName: Icon_1.Icon.Names.interaction_arrows_chevronLeft,
      look: IconLink_1.IconLink.Looks.LEFT,
      onClick: this.onMobileBackwardsClick
    }, this.cleanNavigationItems.find(function (item) {
      return item.isSelected;
    }).label), React.createElement(IconLink_1.IconLink, {
      className: CSSPrefix_1.lsgPre + "header-drawer-close-link",
      iconName: Icon_1.Icon.Names.interaction___close,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: this.closeMenu
    }, utils_1.Localization.texts && utils_1.Localization.texts.lsg.component.Header.closeDrawer)), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "header-drawer-contents"
    }, drawerNavigationItems.filter(function (item) {
      return !(_this.state.isMobile && item.noMobile);
    }).map(function (item) {
      return React.createElement("div", {
        className: CSSPrefix_1.lsgPre + "header-drawer-inner-block",
        key: item.targetValue
      }, React.createElement("div", {
        className: CSSPrefix_1.lsgPre + "header-drawer-inner-title",
        role: "heading",
        "aria-level": 2
      }, item.label), React.createElement(IndicatorLinks_1.IndicatorLinks, {
        activeIndex: item.children.findIndex(function (lvl3) {
          return lvl3.isActive;
        }),
        indicator: true
      }, item.children.map(function (lvl3) {
        if (lvl3.children.length > 0) {
          // tslint:disable no-console
          console.warn("Your Portalnavigation has more than 3 levels. Please check your navigationObject."); // tslint:enable no-console
        }

        return React.createElement(IndicatorLinks_1.IndicatorLinks.Link, __assign({}, _this.getLink(lvl3, {}, true), {
          label: lvl3.label.toString(),
          href: lvl3.href,
          iconName: lvl3.iconName,
          key: lvl3.targetValue,
          onKeyDown: _this.onItemKeyDown,
          refCallback: function refCallback(r) {
            if (lvl3.isSelected) {
              _this.selectedElementRef = r;
            }
          }
        }));
      })));
    } // #########################################################
    // #            End Content of desktop Drawer              #
    // #########################################################
    )))));
    return result;
  };

  Header.defaultProps = {
    navigationObject: []
  };
  return Header;
}(React.Component);

exports.Header = Header;